import React, { useState } from 'react';
import Button from '../../../forms/inputs/button';
import { useI18n } from '../../utilities/i18n';
import { useHistory } from 'react-router-dom'
import Api from '../Api';
import { usePools } from '../DatabaseContext';
import { useErrors } from './ErrorsContext';

export default function SaveAndContinue({ id, data, next, text }) {
    const i18n = useI18n()
    const history = useHistory();
    const { setErrors } = useErrors();
    const { setPool } = usePools();
    const [busy, setBusy] = useState(false)

    const save = async () => {
        setBusy(true)
        setErrors(null)

        try {
            let response = null;

            if (id) {
                response = await Api.updateConfiguration(id, data)
            } else {
                response = await Api.createConfiguration(data)
                id = response.data.id
            }

            setPool(response.data)
        } catch (error) {
            const response = (error?.response?.data?.errors || {});

            const errors = Object.keys(response).reduce((previous, current) => {
                previous[current] = response[current][0]

                return previous;
            }, {})

            setBusy(false)
            setErrors(errors)

            return;
        }

        setBusy(false)

        history.push(`/${id}/${next}`)
    }

    return <Button
        busy={ busy }
        disabled={ busy }
        onClick={save}
        className="mt-12"
    >
        { text || i18n?.forms?.saveContinue }
    </Button>;
}
